import * as React from 'react';
import SearchBarForm from '../header/components/SearchBarForm';

export interface ParagraphSearch extends Paragraph {
  relationships: {
    field_search_page: NodeContent;
  };
}

interface SearchFormProps {
  node?: ParagraphSearch;
}

const ParagraphSearchForm: React.FC<SearchFormProps> = function ({ node }) {
  return (
    <div className="pds-m-auto pds-w-full pds-max-w-3xl pds-p-5">
      <SearchBarForm node={node} />
    </div>
  );
};

export default ParagraphSearchForm;
